/**
 *
 * Configures the current environment
 */

import _ from "underscore";
import api from "../config/api";
import { replaceString } from "../utils";

class Environment {
  constructor() {
    this.api = api;
    this.protocol = document.location.protocol;
    this.host = document.location.host;
    this.hostname = `${this.protocol}//${this.host}`;
    this.apiHost = `${this.hostname}${"${api.context}"}`;
    this.appHost = `${this.hostname}${"${app.context}"}`;

    this._created = new Date();
  }

  getAppHost() {
    return this.appHost;
  }

  getApiHost() {
    return this.apiHost;
  }

  // returns a full API endpoint
  getEndpoint(name, config = {}, additionalPath = null) {
    const path = this.getEndpointPath(name, config, additionalPath);

    // return full endpoint when found
    return path ? `${this.getApiHost()}${path}` : false;
  }

  // returns an API endpoint path
  getEndpointPath(name, config = {}, additionalPath = null) {
    let path = this.findApiPath(name);
    if (!path) return false;

    // apply config, if passed in
    if (_.isObject(config) && !_.isEmpty(config)) {
      // replace config props in API URL
      _.each(_.keys(config), (key) => {
        path = replaceString(path, `{${key}}`, config[key]);
      });
    }

    // return endpoint path
    return additionalPath ? `${path}${additionalPath}` : `${path}`;
  }

  // finds a configured API path by name
  findApiPath(name) {
    return this.api[name] ? this.api[name] : null;
  }

  // creates single instance of Environment
  static createInstance() {
    if (!Environment.instance) {
      Environment.instance = new Environment();
    }
    return Environment.instance;
  }
}

// instantiate the singleton
const singleton = Environment.createInstance();

// export the singleton
export { singleton as default };
